export default "__VITE_ASSET__DWh25hfi__"